export enum ReportMode {
  interactive = 'interactive',
  print = 'print',
}
